import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isAfter, startOfDay } from 'date-fns';
import { useFieldArray, useForm } from 'react-hook-form';
import { createEmptyChargeItem } from '~/components/BillClientModal/BillClientItem.utils';
import { BillMode } from '~/components/BillClientModal/BillClientModal.types';
import { useIoContext } from '~/contexts';
import { NetTermsOption } from '../AdHocBillModal.types';
export const useAdHocBillForm = (param)=>{
    let { defaultEmailSubject, defaultEmailContent } = param;
    const { getNow } = useIoContext();
    const now = getNow();
    const form = useForm({
        mode: 'onSubmit',
        defaultValues: {
            mode: BillMode.Now,
            issueDate: now,
            items: [
                createEmptyChargeItem()
            ],
            coverCreditCardFees: true,
            netTerms: NetTermsOption.Immediate,
            includeTermsOfService: false,
            termsOfServiceId: '',
            emailSubject: defaultEmailSubject,
            emailContent: defaultEmailContent
        }
    });
    const items = useFieldArray({
        control: form.control,
        name: 'items'
    });
    const issueDate = form.watch('issueDate');
    const isFutureIssueDate = isAfter(startOfDay(issueDate), startOfDay(now));
    return _object_spread_props(_object_spread({}, form), {
        items,
        now,
        isFutureIssueDate
    });
};
